const React = require('react');
const defaultMessages = require('../../i18n/messages/default');
const { TabGroup, Tabs, Tab, TabPanels,TabPanel, Button } = require("@metro-ui/core");
const PhoneNumber = require('../PhoneNumber/PhoneNumber.js');
const ReactIntl = require('react-intl');
const injectIntl = ReactIntl.injectIntl;
require('./forgot-password.less');

class ForgotPasswordTabs extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        notificationChannel: "email"
      };

      this.onTabChange = this.onTabChange.bind(this);
    }

    onTabChange(event){
        this.setState({ notificationChannel: event });
        this.props.onTabChange(event);
    }

    render(){
        const emailTabContent = this.props.children;
        return(
            <TabGroup label="Email or Mobile number" onChange={this.onTabChange}>
                <Tabs>
                    <Tab name="email" value="email" > {this.props.intl.formatMessage(defaultMessages['email'])}</Tab>
                    <Tab name="mobile" value="mobile">{this.props.intl.formatMessage(defaultMessages['forgotYourPasswordMsgMobile0'])}</Tab>
                </Tabs>
                <TabPanels>
                    <TabPanel name="email">
                        <div className="email-tabs-container">
                            {emailTabContent}
                        </div>
                    </TabPanel>
                    <TabPanel name="mobile">
                        <div className="blueText"> {this.props.intl.formatMessage(defaultMessages['forgotYourPasswordMsgMobile1'])}</div>
                        <br />
                        <div className="blueText"> {this.props.intl.formatMessage(defaultMessages['forgotYourPasswordMsgMobile2'])}</div>
                        <br />
                        <div className="phone-number-wrapper">
                            <PhoneNumber 
                                handlePrefixChange={this.props.handlePrefixChange}
                                storeMobileNumber={this.props.storeMobileNumber}
                            />
                        </div>
                        <br />
                        <form onSubmit={this.props.onForgotPasswordSubmit} noValidate="novalidate">
                            <div className="row form-group forgotPasswordForm loginFields">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="submit-button col-md-6 col-sm-6 col-xs-12">
                                <Button id="submit" type="submit" kind="primaryRaised" style={{ width: "100%", marginBottom: '10px' }} size={"large"} value="Submit" block
                                    isDisabled={!this.props.phoneData}>
                                    {this.props.intl.formatMessage(defaultMessages['submit'])}
                                </Button>
                                </div>
                                <div className="cancel-button col-md-6 col-sm-6 col-xs-12">
                                <Button  id="Cancel" kind="secondary" size="large" value="Cancel" style={{ width: "100%" }}  block onClick={this.props.onForgotPasswordCancel}>
                                    {this.props.intl.formatMessage(defaultMessages['cancel'])}
                                </Button>
                                </div>
                            </div>
                            </div>
                        </form>
                    </TabPanel>
                </TabPanels>
            </TabGroup>
        )
    }
}

module.exports = injectIntl(ForgotPasswordTabs);